import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@hybrid-iptv/ui/tokens.css";
import "@hybrid-iptv/ui/components.css";
import "./app.css";
import "./epg/epg.css";
import { App, queryClient } from "./App.js";
import { installKeyboardOnDemand } from "./components/keyboardOnDemand.js";
import { installFocusReturn } from "./components/focusReturn.js";
import { installDebugBridge } from "./debug/deviceState.js";
import { registerServiceWorker } from "./pwa/sw-register.js";
import { LaunchDone } from "./launchDone.js";
import { loadBrand } from "./brand.js";

// Text boxes stay inert until the viewer clicks one, so the D-pad passing over a
// field never raises the on-screen keyboard (owner 2026-09-21).
installKeyboardOnDemand();

// Back returns focus to what opened the screen it closes, never to nothing.
installFocusReturn();

// The page's condition for the device debug server's /state and /players. Installs
// nothing outside the APK, where there is a debug server to call it.
installDebugBridge({ queryClient });

// The app's name comes from the build it runs in (brand.ts): known before the first
// render, so no screen draws one name and then another.
void loadBrand().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
      <LaunchDone />
    </StrictMode>
  );
});

registerServiceWorker();
